// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"f5bb7626","301":"299d59e1","385":"6f78c763","432":"22964e99","488":"52061ce5","713":"d3d43314","877":"7bd828fd","982":"f187adab"}[chunkId] + ".chunk.js";
};